@if (userService.isUserConnected()){
  <div class="nav-bar">
    <div class="pvmo-action-list">
      @let logoSrc = src();
      @if (logoSrc && toggledMenu) {
        <ml-img [src]="logoSrc" [title]="brandImageName()"/>
      }
      <ml-icon-button [label]="'application.nav.home' | translate"
                      [ariaLabel]="'application.nav.home' | translate" [icon]="'home'"
                      [isActive]="isHomeActive()" [toggled]="toggledMenu"
                      (eventOnClickEmitter)="homeClicked()"></ml-icon-button>
      <ml-icon-button [label]="'application.nav.simulation' | translate"
                      [ariaLabel]="'application.nav.simulation' | translate" [icon]="'file-payslip'"
                      [isActive]="isSimulationActive()" [toggled]="toggledMenu"
                      (eventOnClickEmitter)="simulationClicked()"></ml-icon-button>
      <ml-icon-button [label]="'application.nav.records' | translate" [ariaLabel]="'application.nav.records' | translate"
                      [icon]="'folder-open'" [isActive]="isRecordsActive()" [toggled]="toggledMenu"
                      (eventOnClickEmitter)="recordsClicked()"></ml-icon-button>
      <ml-icon-button [label]="'application.nav.leads' | translate" [ariaLabel]="'application.nav.leads' | translate"
                      [icon]="'folder-open'" [isActive]="isLeadsActive()" [toggled]="toggledMenu"
                      (eventOnClickEmitter)="leadsClicked()"></ml-icon-button>
      <ml-icon-button [label]="'application.nav.products' | translate"
                      [ariaLabel]="'application.nav.products' | translate" [icon]="'book'" [toggled]="toggledMenu"
                      [disabled]="true"></ml-icon-button>
      <ml-icon-button [label]="'application.nav.oav' | translate" [ariaLabel]="'application.nav.oav' | translate"
                      [icon]="'tools'" [toggled]="toggledMenu" [disabled]="true"></ml-icon-button>
      @if (isUserAdmin()) {
        <ml-icon-button [label]="'application.nav.users' | translate" [ariaLabel]="'application.nav.users' | translate"
                        [icon]="'people'" [toggled]="toggledMenu" [isActive]="isAdministrationActive()" (eventOnClickEmitter)="administrationClicked()"></ml-icon-button>
      }
    </div>
    <div class="pvmo-settings-list">
      <ml-icon-button routerLink="/parameters" [label]="'application.nav.parameters' | translate"
                      [ariaLabel]="'application.nav.parameters' | translate" [icon]="'setting'" [toggled]="toggledMenu"
                      (eventOnClickEmitter)="parametersClick()" [isActive]="isParametersActive()"></ml-icon-button>
      <ml-icon-button [label]="'application.nav.logout' | translate"
                      [ariaLabel]="'application.nav.logout' | translate" [icon]="'exit'" [toggled]="toggledMenu"
                      (eventOnClickEmitter)="logout()"/>
    </div>
  </div>
  <button [class]="`burger-menu${toggledMenu ? '-hidden' : ''}`" (click)="toggledMenu = true">Menu</button>
  @if (toggledMenu) {
    <form novalidate (submit)="$event.preventDefault();">
      <div class="show-items">
        <ml-select-signal [mapValues]="menuMobile" [formField]="navBarForm.select"></ml-select-signal>
      </div>
    </form>

  }
}
